import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    country: '',
    time: ''
  });
  const names = ['Alejandro', 'María', 'Carlos', 'Sofía', 'Juan', 'Laura', 'Diego', 'Valentina', 'Andrés', 'Camila'];
  const countries = ['México', 'Colombia', 'España', 'Argentina', 'Chile', 'Perú', 'Ecuador'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'recién ahora'];
  useEffect(() => {
    const showRandomPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCountry = countries[Math.floor(Math.random() * countries.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];
      setCurrentPurchase({
        name: randomName,
        country: randomCountry,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showRandomPopup, 10000);
    // Interval for subsequent popups (every 20-30 seconds)
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        setTimeout(showRandomPopup, Math.random() * 10000 + 5000);
      }
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 animate-fade-in-up" data-id="element-168">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-4 max-w-sm" data-id="element-169">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-170">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-171" />
        </div>
        <div data-id="element-172">
          <p className="text-sm text-gray-800" data-id="element-173">
            <span className="font-bold" data-id="element-174">{currentPurchase.name}</span> de{' '}
            {currentPurchase.country}
          </p>
          <p className="text-xs font-medium text-gray-900 mt-0.5" data-id="element-175">
            Compró La Saga del Arquitecto No-Code
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-176">{currentPurchase.time}</p>
        </div>
      </div>
    </div>;
}